var LevelBonusShareRedirector = xClass("LevelBonusShareRedirector", BaseRedirector)
StrategyConfrim = null;
LevelBonusShareRedirector.prototype.getName = function () {
    return "level_bonus";
}
LevelBonusShareRedirector.prototype.hasHighPriorityAction = function() {
    return false;
}
LevelBonusShareRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param
    var um = UserManager.getInstance();
    console.log(um);
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }
    if (um.uid && param.inviteCode) {
        if (param["inviteCode"] && param["inviteCode"] === um.uid) {
            //不能给自己加
            console.log("不能邀请自己哦");
            return true
        }
        if (!_G.kIsNewUser) {
            //必须是新用户
            console.log("必须得是新用户");
            return true
        }

        let http = LevelBonusShareInHttp.new();
        http.addEventListener(Events.kComplete, () => {})
        http.addEventListener(Events.kError, (evt = {}) => {
            Toast.make(quickGetErrorText(evt.data, "链接已经失效！"));
        })
        http.load({inviteCode: param.inviteCode});
    }
    return true
}

module.exports = LevelBonusShareRedirector